<template>
  <div class="flex flex-col gap-1 justify-center" data-ui="page-preview" :class="{ 'flex w-full h-full  items-center justify-center' : center}">

    <!-- Template infos -->
    <div v-if="showInfo" class="flex w-full bg-trader-dark-gray px-1">
      <span class="flex-grow">{{templateName}}</span>
      <span>{{templateId}}</span>
    </div>

    <!-- Preview -->
    <div v-if="ready" class="relative overflow-auto " :class="{'border-4 border-trader-red' : highlight}" :style="styleObject">
      <object type="image/svg+xml" class="w-full h-full"
              :data="'/api/v3/preview/page/'+pageId+ '/product/' + productId + '/template/' + templateId + '?callback=p'+productId+'_'+this.random+'&show_notes='+showNotes+'&background='+articleTemplateBackground+'&quality='+quality">
        <param name="type" value="image/svg+xml">
      </object>
      <div class="z-10 absolute top-0 left-0 bottom-0 right-0"></div>
    </div>


    <!-- Background color buttons -->
    <div v-if="showOptions" class="flex w-full gap-2 bg-trader-dark-gray rounded p-1">
      <div data-ui="background-color-transparent"
          class="text-center w-1/3 px-1 cursor-pointer rounded "
          :class="{'bg-trader-blue  text-white': articleTemplateBackground === 'transparent' }"
          @click="changeBackground('transparent')">
        Transparent
      </div>
      <div data-ui="background-color-black"
          class="text-center w-1/3 px-1 cursor-pointer rounded"
          :class="{'bg-trader-blue text-white': articleTemplateBackground === 'black' }"
          @click="changeBackground('black')">
        Schwarz
      </div>
      <div data-ui="background-color-white"
          class="text-center w-1/3 px-1 cursor-pointer rounded"
          :class="{'bg-trader-blue text-white': articleTemplateBackground === 'white' }"
          @click="changeBackground('white')">
        Weiß
      </div>
    </div>


  </div>
</template>

<script >
import {mapActions, mapState} from "vuex";

export default {
  props: {
    pageId: {
      type: Number,
      default: 0,
    },
    productId: {
      type: Number,
      default: 0,
    },
    templateId: {
      type: Number,
      default: 0,
    },
    templateName: {
      type: String,
      default: '',
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    hMax: {
      type: Number,
      default: 0,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    showOptions: {
      type: Boolean,
      default: false,
    },
    quality: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    //...mapState('user', ['isAdmin']),
    ...mapState('settings', ['showNumbers', 'showNotes', 'articleTemplateBackground']),
  },
  data() {
    
    return {
      styleObject: {
        width: '100%',
        height: this.hMax > 0 ? this.hMax + 'px' : '100%',
      },
      ready: false,
      random: Math.floor(Math.random() * 999999999),
    }
  },
  methods: {
    ...mapActions('settings', ['setArticleTemplateBackground']),
    changeBackground(value) {
      this.setArticleTemplateBackground(value);
    },
  },
  watch: {
    productId(newValue, oldValue) {
      this.styleObject = {};
      this.ready = false;

      window.crossApi.callbacks['p'+this.productId+'_'+this.random] = (w,h) => {

        this.styleObject = {
          width: w + 'px',
          height: h + 'px',
        };
      };
    }
  },
  mounted() {
    this.ready = true;
  },
  created() {
    window.crossApi.callbacks['p'+this.productId+'_'+this.random] = (w,h) => {
      
      this.styleObject = {
        width: w + 'px',
        height: h + 'px',
      };
    };
    this.ready = true;
  }
}

</script>
